// extracted by mini-css-extract-plugin
export default {"filtersSection":"user-details-page_filtersSection__1hIb8","tableColumn":"user-details-page_tableColumn__4BsOE"};